/*!*
 * @author yueheqin
 * @date 2019/6/17
 * @project zujuanzaixian
 * @desc
 */
import {personUserApi, groupUserApi, vipInfoApi} from '../api/vip'
import {wrapFnExecOnce} from '../utils/wrap-fn-exec-once'

const powerIcon = {
  '智能组卷': 'iconzhinengzujuan',
  '模板组卷': 'iconmobanzujuan',
  '考点组卷': 'iconkaodianzujuan',
  '章节组卷': 'iconzhangjiezujuan',
  '名校名卷': 'iconmingxiaomingjuan',
  '每日上新': 'iconmeirishangxin',
  '试卷存档': 'iconcundangjilu',
  '个人题库': 'icongerentiku',
  '试卷下载': 'iconxiazaijilu',
  '答题卡下载': 'icondatikaxiazai',
  '单题下载': 'icondantixiazai',
  '原创试题': 'iconshitipingjia'
}

let state = {
  personData: {},
  groupData: {},
  payData: {}
}
let getters = {
  powerIcon () {
    return powerIcon
  }
}
let mutations = {
  updatePersonData (state, data) {
    console.log('mutations updatePersonData:', data)
    state.personData = data
  },
  updateGroupData (state, data) {
    console.log('mutations updateGroupData:', data)
    state.groupData = data
  },
  updatePayData (state, data) {
    console.log('mutations updatePayData:', data)
    state.payData = data
  }
}
let actions = {
  getPersonData: wrapFnExecOnce(function (setState, {state, commit}) {
    personUserApi({loading: '1'}).then(res => {
      setState('loaded')
      commit('updatePersonData', res.data)
    }).catch(() => {
      setState('fail')
    })
  }),
  getGroupData: wrapFnExecOnce(function (setState, {state, commit}) {
    groupUserApi({loading: '1'}).then(res => {
      setState('loaded')
      commit('updateGroupData', res.data)
    }).catch(() => {
      setState('fail')
    })
  }),
  getPayData: wrapFnExecOnce(function (setState, {state, commit}) {
    vipInfoApi({}, {loading: '1'}).then(res => {
      setState('loaded')
      commit('updatePayData', res.data)
    }).catch(() => {
      setState('fail')
    })
  })
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
